/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('PhysicalResource_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource(baseUrl+'rest/physicalResources/:id',{}, {
            query: { method: 'GET', isArray: true },
            get:   { method: 'GET' }
        });
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('PhysicalResource',["PhysicalResource_Resource","CategoryData","ServiceData","PhysicalResourceData",
        function (PhysicalResource_Resource,CategoryData,ServiceData,PhysicalResourceData)
        {
        //PhysicalResource inherit of $resource

        var  PhysicalResource = function (resource) {
            this.id = null;
            this.isDeleted = false;
            this.label = "";
            this.number = 1;
            this.services = [];
            this.hasPlanning = true;
            this.onLineBooking = true;
            this.order = null;
            this.version = null;
            if (resource!==undefined && resource!=null)
                this.loadObject(resource);

            PhysicalResourceData.add(this);
        };

        PhysicalResource.prototype.getObjectResource = function() {
            let rsPhysicalResource = new PhysicalResource_Resource();
            rsPhysicalResource.id = this.id;
            rsPhysicalResource.isDeleted = this.isDeleted;
            rsPhysicalResource.label =this.label;
            rsPhysicalResource.number =this.number;
            rsPhysicalResource.hasPlanning = this.hasPlanning;
            rsPhysicalResource.onLineBooking = this.onLineBooking;
            rsPhysicalResource.order = this.order;

            rsPhysicalResource.servicesId = [];
            for (let i = 0 ; i < this.services.length ; i++) {
                rsPhysicalResource.servicesId.push(this.services[i].getId());
            }

            return rsPhysicalResource;
        };

        PhysicalResource.prototype.loadObject = function(object) {
            if (!this.id)
                this.id = object.id;
            this.isDeleted = object.isDeleted;
            this.label = object.label;
            this.number = object.number;
            this.hasPlanning = object.hasPlanning;
            this.onLineBooking = object.onLineBooking;
            this.order = object.order;
            this.servicesId = object.servicesId;
            if (object.version)
                this.version = object.version;
        }
        PhysicalResource.prototype.loadRef = function () {
            //load ref from ids
            if (this.servicesId && CategoryData.loaded()) {
                let newServices = [];
                for (let i = 0; i < this.servicesId.length; i++) {
                    let service = ServiceData.getById(this.servicesId[i]);
                    if (service != null) {
                        newServices.push(service);
                    }
                }
                this.services = newServices;
            }

            delete this.servicesId;
        }

        PhysicalResource.prototype.getId = function () {
            return this.id;
        }
        PhysicalResource.prototype.setId = function (id) {
            this.id = id;
        }
        PhysicalResource.prototype.getLabel = function () {
            return this.label;
        }
        PhysicalResource.prototype.getId = function () {
            return this.id;
        }
        PhysicalResource.prototype.getServices = function () {
            return this.services;
        }
        PhysicalResource.prototype.hasService = function (service) {
            let has = false;
            if (this.services != null)
                has = this.services.indexOf(service) != -1;
            return has;
        }
        PhysicalResource.prototype.addService = function (service) {
            if (this.services.indexOf(service) == -1)
                this.services.push(service);
        }
        PhysicalResource.prototype.removeService = function (service) {
            let index = this.services.indexOf(service)
            if (index != -1)
                this.services.splice(index, 1);
        }

        PhysicalResource.prototype.statFilter = function (arrayOfDays) {
            return (this.hasPlanning && this.isWorkingOnPeriod(arrayOfDays));
        }

        PhysicalResource.prototype.isWorkingOnPeriod = function(arrayOfDays){
            let isWorkingOnPeriod = false;
            for(let i = 0; i < arrayOfDays.length; i++){
                isWorkingOnPeriod = isWorkingOnPeriod || arrayOfDays[i].prIsWorking(this.id, this.prUnitId);

                if(isWorkingOnPeriod == true){
                    break;
                }
            }
            return isWorkingOnPeriod;
        }

        return PhysicalResource;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('PhysicalResourceSrv',["$log","PhysicalResource_Resource","PhysicalResource","PhysicalResourceData","CategoryData","UserActionData","ServerSrv",
        function ($log,PhysicalResource_Resource,PhysicalResource,PhysicalResourceData,CategoryData,UserActionData,ServerSrv)
        {
            var  prSrv = {};

            prSrv.query = function(successFunction,errorFunction)
            {
                PhysicalResource_Resource.query(
                    {}, //params
                    function (data) {   //success
                        PhysicalResourceData.clear();
                        for (var i=0;i< data.length;i++)
                            new PhysicalResource(data[i]);//auto register to DATA

                        if (successFunction!== undefined)
                            successFunction(PhysicalResourceData.getActiveList());

                    },
                    function (data) {
                        $log.error(data);
                        if (errorFunction!== undefined)
                            errorFunction(data);
                    });
            }
            prSrv.reload =  function(physicalResource,successFunction,errorFunction)
            {
                var physicalResourceSrv = new PhysicalResource_Resource();
                physicalResourceSrv.$get({id:physicalResource.getId()}, //params : id
                    function (data) {
                        physicalResource.loadObject(data);
                        if (successFunction !=undefined)
                            successFunction(data);
                    },
                    function (data) {
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    });
            }
            prSrv.restore =  function(physicalResource,successFunction,errorFunction)
            {
                PhysicalResourceData.restore(physicalResource);
                ServerSrv.startSavingProcess(prSrv.restoreSync, physicalResource, successFunction, errorFunction);
            };
            prSrv.restoreSync =  function(physicalResource,successFunction,errorFunction)
            {

                var physicalResourceRes = physicalResource.getObjectResource();
                physicalResourceRes.$save({}, //no params
                    function (data) {
                        try{
                            physicalResource.setId(data.id);
                            //TODO UserActionData.add(data.userAction);
                            if (successFunction !=undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try{
                            if (errorFunction !=undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

            }
            prSrv.save =  function(physicalResource,successFunction,errorFunction)
            {
                ServerSrv.startSavingProcess(prSrv.saveSync, physicalResource, successFunction, errorFunction);
            };
            prSrv.saveSync =  function(physicalResource,successFunction,errorFunction)
            {

                var physicalResourceRes = physicalResource.getObjectResource();
                physicalResourceRes.$save({}, //no params
                    function (data) {
                        try{
                            physicalResource.setId(data.id);
                            if (!physicalResource.version || (data.version && data.version > physicalResource.version))
                                physicalResource.version = data.version;
                            //TODO UserActionData.add(data.userAction);
                            if (successFunction !=undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try{
                            if (errorFunction !=undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

            }
            prSrv.remove =  function(physicalResource,successFunction,errorFunction)
            {
                PhysicalResourceData.remove(physicalResource);
                ServerSrv.startSavingProcess(prSrv.removeSync, physicalResource, successFunction, errorFunction);
            };
            prSrv.removeSync =  function(physicalResource,successFunction,errorFunction)
            {
                var physicalResourceSrv = new PhysicalResource_Resource();
                physicalResourceSrv.$remove({id:physicalResource.getId()}, //params : id
                    function (data) {
                        try{
                            //TODO UserActionData.add(data.userAction);
                            if (successFunction !=undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try{
                            if (errorFunction !=undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

            }
            prSrv.updateLocally =  function(id,objectToRestore)
            {
                var physicalResource =  PhysicalResourceData.getById(id)
                if (physicalResource!=null)
                {
                    physicalResource.loadObject(objectToRestore);
                    physicalResource.loadRef();
                }
                return physicalResource;
            }
            prSrv.removeLocally =  function(id,object)
            {
                var physicalResource =  PhysicalResourceData.getById(id)
                if (physicalResource!=null)
                {
                    PhysicalResourceData.remove(physicalResource);
                }
                return physicalResource;
            }
            prSrv.addLocally =  function(id,objectToRestore)
            {
                var physicalResource =  PhysicalResourceData.getById(id)
                if (physicalResource!=null)
                {
                    physicalResource.loadObject(objectToRestore);
                    physicalResource.id = id;
                    physicalResource.loadRef();
                    PhysicalResourceData.add(physicalResource);
                }
                return physicalResource;
            }
            prSrv.loadRef=  function()
            {
                var physicalResources = PhysicalResourceData.getActiveList();
                for (var i=0;i<physicalResources.length;i++)
                    physicalResources[i].loadRef();
            }

            return prSrv;
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('PhysicalResourceData',["$log", function ($log)
    {
        var  prDataSrv =
        {
            indexPhysicalResources : [], //Never deleted (used as index)
            activePhysicalResources : [],//active list
            deletedPhysicalResources : []//deleted items
        };
        prDataSrv.getById =  function(physicalResourceId)
        {
            for (var i=0;i<this.indexPhysicalResources.length;i++)
                if (this.indexPhysicalResources[i].id==physicalResourceId)
                    return this.indexPhysicalResources[i];
            return null;
        }
        prDataSrv.getIndexOf =  function(pr)
        {
            if (pr)
                return this.indexPhysicalResources.indexOf(pr);
            return -1;
        }
        prDataSrv.getByIndex =  function(prIndex)
        {
            if (prIndex>=0 && prIndex<this.indexPhysicalResources.length)
                return this.indexPhysicalResources[prIndex];
            else
                return null;
        }
        prDataSrv.add =  function(physicalResource)
        {
            var prArray = this.activePhysicalResources;
            if (physicalResource.isDeleted)
                prArray =  this.deletedPhysicalResources;
            var index =  this.indexPhysicalResources.indexOf(physicalResource);
            if (index!=-1)
            {
                var realIndex = prArray.indexOf(physicalResource);
                if (realIndex==-1)
                    prArray.push(physicalResource);
            }
            else
            {
                index = this.indexPhysicalResources.length
                this.indexPhysicalResources.push(physicalResource);
                prArray.push(physicalResource);
            }
            return index;
        }
        prDataSrv.remove =  function(physicalResource) //Soft Remove
        {
            var index =  this.activePhysicalResources.indexOf(physicalResource);
            if (index!=-1)
            {
                this.activePhysicalResources.splice(index, 1);
                this.deletedPhysicalResources.push(physicalResource)
                physicalResource.isDeleted=true;
            }

        }
        prDataSrv.restore =  function(physicalResource) //Soft Remove
        {
            var index =  this.deletedPhysicalResources.indexOf(physicalResource);
            if (index!=-1)
            {
                this.deletedPhysicalResources.splice(index, 1);
                this.activePhysicalResources.push(physicalResource)
                physicalResource.isDeleted=false;
            }

        }
        prDataSrv.clear =  function()
        {
            this.indexPhysicalResources = [];
            this.activePhysicalResources = [];
            this.deletedPhysicalResources = [];
        }
        prDataSrv.getActiveList =  function()
        {
            return this.activePhysicalResources;
        }
        prDataSrv.getDeletedList =  function()
        {
            return this.deletedPhysicalResources;
        }

        return   prDataSrv;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/PhysicalResource.js